import { Button } from "@/components/buttons/Button";
import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { INiche } from "@/common/services/types";
import { useFollowNicheQueries } from "@/common/hooks/useFollowNicheQueries";
import { useEffect, useState } from "react";
import { getExperimentVariant } from "@/common/utils/experiment";
import { EXPERIMENT_NICHE_PREVIEW, VARIANT_CONTROL } from "@/common/services/experiment/constants";
import { NichePreviewClickInitiator } from "@/common/buses";
import ChevronIcon from "@/common/images/icons/chevron.svg?react";
import "./NichePreviewButton.scss";

interface IProps {
  niche: INiche;
  following: boolean;
  withJoin?: boolean;
  onFollow: (id: string, status: boolean) => void;
  onPreviewClick: (initiator: NichePreviewClickInitiator) => void;
}

export const NichePreviewButton = ({ niche, following, withJoin = true, onFollow, onPreviewClick }: IProps) => {
  const { onFollowAction: handleFollow } = useFollowNicheQueries({ nicheId: niche.id, following, sendFollowState: onFollow });
  const [actionType, setActionType] = useState<null | "watch" | "join" | "open">(null);
  const navigate = useNavigate();

  const onOpenNiche = (initiator: NichePreviewClickInitiator) => () => {
    onPreviewClick(initiator);

    navigate(routes.niche(niche.id));
  };

  const onJoinNiche = () => {
    onPreviewClick("join button");

    handleFollow();
  };

  useEffect(() => {
    (async () => {
      if (!withJoin) {
        setActionType("open");
        return;
      }

      const variant = await getExperimentVariant(EXPERIMENT_NICHE_PREVIEW, VARIANT_CONTROL);
      setActionType(variant === VARIANT_CONTROL ? "join" : "watch");
    })();
  }, [withJoin]);

  const renderActionButton = () => {
    switch (actionType) {
    case "join":
      return (
        <Button variant={following ? "secondary" : "primary"} size="xs" onClick={onJoinNiche}>
          {following ? "Leave" : "Join"}
        </Button>
      );
    case "watch":
      return (
        <Button variant="primary" size="xs" onClick={onOpenNiche("watch button")}>
            Watch
        </Button>
      );
    case "open":
      return (
        <Button variant="secondary" round size="xs" onClick={onOpenNiche("arrow button")}>
          <ChevronIcon />
        </Button>
      );
    default:
      return null;
    }
  };

  return (
    <div className="NichePreviewButton">
      {renderActionButton()}
    </div>
  );
};
